import { Component, Input, OnInit } from '@angular/core';
import { FunctionalCapabilitiesRibbonTileSection } from 'src/app/model/shared/functional-capabilities-ribbon-tile-section';

@Component({
  selector: 'app-functional-capabilities-ribbon-tile-section',
  templateUrl: './functional-capabilities-ribbon-tile-section.component.html',
  styleUrls: ['./functional-capabilities-ribbon-tile-section.component.scss']
})
export class FunctionalCapabilitiesRibbonTileSectionComponent implements OnInit {
  @Input() ribbonTileSections: FunctionalCapabilitiesRibbonTileSection[] = [];
  @Input() isPaymentsPage: boolean = false;
  @Input() isRibbonTile: boolean = false;
  @Input() isRibbonTileSawToothVertical: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
